"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var time_1 = require("../../common/helpers/time");
var hours_list_1 = require("../../common/constants/hours_list");
var minutes_list_1 = require("../../common/constants/minutes_list");
;
var AdminEditDriveSession = /** @class */ (function () {
    function AdminEditDriveSession(DrivesModel, UserService, UsersModel) {
        this.state = {
            driveSession: {
                id: 0,
                sessionLengthHours: "0",
                sessionLengthMinutes: "0",
                overrideLocation: false,
                session_length: 0,
                formatTime: "",
                formatDate: "",
                toggleStudentSchoolOverride: false,
                zones: [],
                zoneparts: [],
                sectors: [],
                type: {
                    id: 0,
                    name: "",
                    allow_custom_pickup_locations: false,
                    hidden: false,
                    allow_custom_dropoff_locations: false,
                    reportcardtype: {
                        name: "",
                    },
                },
                location: {
                    id: 0,
                    name: "",
                    school_id: 0,
                    zones: [],
                    zoneparts: [],
                },
                pickuplocation: undefined,
                dropofflocation: undefined,
                private: "N",
                student: undefined,
                instructor: undefined,
                vehicle: undefined,
                instructor_id: null,
                plots: [],
                observation: false,
                students: [],
                notes: null,
                student_id: 0,
                status: "Available",
            },
            form: {
                hoursList: hours_list_1.hours_list,
                minutesList: minutes_list_1.minutes_list,
                sessiontypes: [],
                campuses: [], //school.locations  // can just be vm.campuses and set in init
                selectAllSectorsLabel: "",
                // selectAllSectors // method
                zones: [], // available zones to select
                sectors: [], // the available sectors to select
                instructors: [],
                vehicles: [],
                submitted: false,
                busy: false,
            },
            rules: {
                sectorsRequired: true,
                hasStudents: false, // this should be a boolean
                hasSectors: false,
                noteLengthValid: true,
            },
        };
        this.DrivesModel = DrivesModel;
        this.UserService = UserService;
        this.UsersModel = UsersModel;
        this.updateSessionDate = this.updateSessionDate.bind(this);
        this.updateSessionTime = this.updateSessionTime.bind(this);
    }
    AdminEditDriveSession.prototype.setDriveSession = function (data) {
        this.state.driveSession = data;
    };
    AdminEditDriveSession.prototype.hasStudents = function () {
        var studentsOnSession = [];
        if (this.state.driveSession.hasOwnProperty("student") &&
            this.state.driveSession.student !== null) {
            studentsOnSession.push(this.state.driveSession.student);
        }
        if (this.state.driveSession.observation === true &&
            !this.state.driveSession.students) {
            this.state.driveSession.students = [];
        }
        if (this.state.driveSession.hasOwnProperty("students") &&
            this.state.driveSession.students.length > 0) {
            this.state.driveSession.students.forEach(function (student) {
                studentsOnSession.push(student);
            });
        }
        if (studentsOnSession.length === 0) {
            return false;
        }
        var result = studentsOnSession.length > 0;
        this.state.rules.hasStudents = result;
        return result;
    };
    AdminEditDriveSession.prototype.noteLengthValid = function () {
        if (!this.state.driveSession.notes) {
            return true;
        }
        return this.state.driveSession.notes.length <= 500;
    };
    /**
     * Whether or not this session can be deleted. Defaults to true, may change in the future.
     */
    AdminEditDriveSession.prototype.driveSessionCanBeDeleted = function () {
        if (!this.state.driveSession.drive_date ||
            !this.state.driveSession.start_time) {
            return false;
        }
        var hasStudents = false;
        if (this.state.driveSession.student_id !== null) {
            hasStudents = true;
        }
        if (this.state.driveSession.hasOwnProperty("students") &&
            this.state.driveSession.students.length > 0) {
            hasStudents = true;
        }
        // Handle both Date objects and string formats
        var dateStr;
        var timeStr;
        // Convert drive_date to YYYY-MM-DD string if it's a Date object
        if (this.state.driveSession.drive_date instanceof Date) {
            dateStr = (0, time_1.formatDateTime)(this.state.driveSession.drive_date, "YYYY-MM-DD");
        }
        else {
            dateStr = this.state.driveSession.drive_date;
        }
        // Convert start_time to HH:mm:ss string if it's a Date object
        if (this.state.driveSession.start_time instanceof Date) {
            timeStr = (0, time_1.formatDateTime)(this.state.driveSession.start_time, "HH:mm:ss");
        }
        else {
            timeStr = this.state.driveSession.start_time;
        }
        var dateTimeString = "".concat(dateStr, " ").concat(timeStr);
        var driveDateTime = (0, time_1.dateTimeStringToDate)(dateTimeString);
        return (((0, time_1.isBefore)(driveDateTime, new Date()) ||
            this.state.driveSession.status === "Available") &&
            hasStudents === false); // this.state.driveSession.status == 'Available' || this.state.driveSession.status == 'Complete'
    };
    AdminEditDriveSession.prototype.resetForm = function () {
        this.state.form.sectors = [];
        this.state.form.zones = [];
    };
    AdminEditDriveSession.prototype.resetDriveSession = function () {
        // Clear zones and sectors
        this.state.driveSession.sectors = [];
        this.state.driveSession.zoneparts = [];
    };
    AdminEditDriveSession.prototype.checkSelectedSectors = function () {
        if (this.state.rules.sectorsRequired === false) {
            this.state.rules.hasSectors = true;
            return true;
        }
        this.state.rules.hasSectors = false;
        var hasSectors = [].concat(this.state.form.sectors).filter(function (sector) { return sector.selected; })
            .length > 0;
        this.state.rules.hasSectors = hasSectors;
        return this.state.rules.hasSectors;
    };
    AdminEditDriveSession.prototype.updateSelectAllZonesLabel = function () {
        var label = "";
        var zones = []
            .concat.apply([], this.state.form.zones).filter(function (zone) { return zone.selected; });
        if (zones.length === 1) {
            label = "Select all Sectors in Zone ";
        }
        else {
            label = "Select all Sectors in Zones ";
        }
        zones.forEach(function (zone) {
            label += " " + zone.name + ", ";
        });
        label.trim().replace(/,+$/, "").replace(/,\s*$/, "");
        label = label.slice(0, -2);
        this.state.form.selectAllSectorsLabel = label;
    };
    AdminEditDriveSession.prototype.updateSessionDate = function (newDate) {
        //used with vue flatpickr - receives Date objects, not strings
        if (newDate.selected && newDate.selected.length > 0) {
            // Store as YYYY-MM-DD string format for consistency with backend
            var date = newDate.selected[0];
            this.state.driveSession.drive_date = (0, time_1.formatDateTime)(date, "YYYY-MM-DD");
        }
    };
    AdminEditDriveSession.prototype.updateSessionTime = function (newTime) {
        //used with vue flatpickr - receives Date objects, not strings
        if (newTime.selected && newTime.selected.length > 0) {
            // Store as HH:mm:ss string format for consistency with backend
            var time = newTime.selected[0];
            this.state.driveSession.start_time = (0, time_1.formatDateTime)(time, "HH:mm:ss");
        }
    };
    return AdminEditDriveSession;
}());
AdminEditDriveSession.$inject = ["DrivesModel", "UserService", "UsersModel"];
exports.default = AdminEditDriveSession;
